import React from 'react';
import Sidenavigation from '../layout/Sidenavigation';
import Topnavigation from '../layout/Topnavigation';
import Listcontent from '../sections/HelpdeskV-Hampers-Details/Content';
import { Helmet } from "react-helmet";

function HelpdeskVHampersDetails() {

    return (
        <div className="ms-body ms-aside-left-open ms-primary-theme">
            {/* title  */}
            <Helmet>
                <title>Hamper Details</title>
            </Helmet>

            {/* sidebar start  */}
            <Sidenavigation />
            {/* sidebar end  */}

            <main className="body-content">

                {/* Topnavigation start */}
                <Topnavigation />
                {/* Topnavigation end  */}

                {/* page content start  */}
                <Listcontent />
                {/* page content end  */}

            </main>

        </div>
    );
};

export default HelpdeskVHampersDetails;